<template>
    <div>
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                        <a @click.prevent="handleBack('/')" class="btn btn--icon btn--white">
                            <i class="material-icons">keyboard_arrow_left</i>
                        </a>
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">Statistics</h1>
                    </div>
                </div>
            </div>
        </header>


        <div class="intro-content pt--10 pb--10">
            <div class="profile profile--vertical profile--lg">
                <figure class="profile__avatar">
                    <span class="profile__avatar__img">
                        <img :src="user.avatar" />
                    </span>
                </figure>

                <div class="profile__text">
                    <div class="profile__name mb--0">{{ user.nick }}</div>
                </div>
            </div>
        </div>


        <div class="bg--layer-light pt--md pb--md mb--md" v-if="stats">
            <div class="container">
                <ul class="counter mb--0">
                    <li>
                        <span class="counter__title">All games</span>
                        <div class="counter__number">{{ stats.total_games }}</div>
                    </li>
                    <li>
                        <span class="counter__title">Won</span>
                        <div class="counter__number">{{ stats.won }}</div>
                    </li>
                    <li>
                        <span class="counter__title">Won %</span>
                        <div class="counter__number">{{ stats.wonRate }}</div>
                    </li>
                </ul>
            </div>
        </div>

        <SeasonData></SeasonData>


        <div class="bg--layer-light pt--md pb--md mb--lg" v-if="stats">
            <div class="container">
                <div class="row mb--lg">
                    <div class="col-6 offset-3 text--center">
                        <span class="badge badge--lg badge--primary">Stage {{ user.stage }}</span>
                    </div>
                    <div class="col-3 text--right">
                        <a href="" class="info-item__status info-item__status--inline">?</a>
                    </div>
                </div>

                <div class="progress mb--lg">
                    <div class="progress__bar"><span v-bind:style="{ width: stageProgressBar() + '%' }"></span></div>
                    <span class="progress__name">{{ user.xp_points }} XP</span>

                    <div class="progress__info">
                        <span class="opacity--md">Stage {{ user.stage }}</span>
                        <span class="c--success">{{ nextStageXp() }} XP - Stage {{ user.stage+1 }}</span>
                    </div>
                </div>

                <div class="panel bg--layer-dark">
                    <p class="text--center opacity--md mb--md"><strong>Stage reward</strong></p>

                    <div class="row">
                        <div class="col-5 offset-1">
                            <div class="icon-value justify-content--center">
                                <img src="img/icons/xp.png" alt="" /> 400 XP
                            </div>
                        </div>

                        <div class="col-5">
                            <div class="icon-value justify-content--center">
                                <img src="img/icons/coin.png" alt=""> 250 Quids
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <Toplist></Toplist>
        <navigation></navigation>
    </div>
</template>

<script>
    import Navigation from "./partial/Navigation";
    import Toplist from "./partial/DashboardToplist";
    import SeasonData from "./Statistics/UserSeasonData";
    import internalBackRoute from "../mixins/internalBackRoute"
    import authApi from "../api/auth"
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: "Statistics",
        components: {Navigation, Toplist, SeasonData},
        mixins: [internalBackRoute],

        computed: {
            ...mapGetters('auth', [
                'user',
            ]),
        },

        data: function () {
            return {
                stats: null
            }
        },

        created() {
            authApi.loadStat()
            .then((response) => {
                this.stats = response.data
            })

            this.$store.dispatch('auth/loadUser')
        },

        methods: {
            ...mapActions('auth', [
                'loadUser'
            ]),

            nextStageXp() {
                return Math.pow((this.user.stage+1)/0.05, 2)
            },

            currentStageXp() {
                return Math.pow((this.user.stage)/0.05, 2)
            },

            stageProgressBar() {
                let xpToNextStage = this.nextStageXp() - this.currentStageXp()
                let xpGained = this.user.xp_points - this.currentStageXp()

                return Math.round(xpGained/xpToNextStage*100)
            }
        }
    }
</script>